import * as React from 'react';

function SvgCalendar(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" {...props}>
      <path
        d="M4.795 0a.45.45 0 01.448.448v1.41h3.514V.447A.45.45 0 019.205 0h1.161a.45.45 0 01.448.448v1.41h1.293c.824 0 1.493.668 1.493 1.492v10.214c0 .824-.669 1.493-1.493 1.493H1.893A1.493 1.493 0 01.4 13.564V3.35c0-.824.669-1.493 1.493-1.493h1.293V.448A.45.45 0 013.634 0h1.16zm7.212 4.843H1.993v8.547c0 .03.019.057.045.068l.029.006h9.866c.03 0 .057-.019.068-.045l.006-.029V4.843zM7.58 9.286a.45.45 0 01.449.448v1.16a.45.45 0 01-.449.449H6.42a.45.45 0 01-.449-.448V9.734a.45.45 0 01.449-.448h1.16zm-2.785 0a.45.45 0 01.448.448v1.16a.45.45 0 01-.448.449H3.634a.45.45 0 01-.448-.448V9.734a.45.45 0 01.448-.448h1.16zm5.571 0a.45.45 0 01.448.448v1.16a.45.45 0 01-.448.449h-1.16a.45.45 0 01-.449-.448V9.734a.45.45 0 01.448-.448h1.161zM4.795 6.5a.45.45 0 01.448.448v1.16a.45.45 0 01-.448.45H3.634a.45.45 0 01-.448-.45v-1.16a.45.45 0 01.448-.448h1.16zm2.785 0a.45.45 0 01.449.448v1.16a.45.45 0 01-.449.45H6.42a.45.45 0 01-.449-.45v-1.16A.45.45 0 016.42 6.5h1.16zm2.786 0a.45.45 0 01.448.448v1.16a.45.45 0 01-.448.45h-1.16a.45.45 0 01-.449-.45v-1.16a.45.45 0 01.448-.448h1.161z"
        fill="#38B2A6"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCalendar;
